export class ChatEscalationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLadder({ companyId, config = {} }) {
    return this.#http.get(`/api/companies/${companyId}/chat-escalation-ladder`, config);
  }

  async updateLadder({ companyId, groups }) {
    return this.#http.put(`/api/companies/${companyId}/chat-escalation-ladder`, groups);
  }

  async deleteLadder({ companyId }) {
    return this.#http.delete(`/api/companies/${companyId}/chat-escalation-ladder`);
  }
}
